<template>
  <div class="en_item flex_space flex_center_align">
    <div class="company">フォーティーセカンド・ストリート株式会社</div>
    <div class="flex_start tzx_right flex_end">
      <div class="name">担当者</div>
      <div class="ddz flex_colum flex_start">
        <div class="ddz_item flex_start">
          <vab-select
            label-width="0"
            placeholder="選択されていません"
            prop="ddz"
            data-key="ddzconst"
            label-id="label"
            value-id="value"
            data-type="local"
            clearable
          />
        </div>
        <!-- <vab-input
          label-width="0"
          placeholder="担当者名を入力してください"
          prop="proposalBase.managementSeq"
        ></vab-input> -->
      </div>
      <slot name="del">
        <div class="del_box flex_center_align flex_center">
          <div
            class="del_inner flex_center_align flex_center"
            v-on="$listeners"
          >
            <img src="~@/assets/images/close.png" alt="" />
          </div>
        </div>
      </slot>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'EnItem',
  }
</script>

<style lang="scss" scoped>
  .en_item {
    background: #f7f7f7;
    border: 1px solid #efefef;
    border-radius: 4px;
    margin-right: 6px;
    margin-bottom: 6px;
    max-width: 620px;
    ::v-deep {
      .el-input__inner {
        height: 28px;
        width: 200px;
      }
      .el-input--suffix .el-input__inner {
        padding-right: 5px;
      }
    }
    &:last-child {
      margin-bottom: 0px;
    }
    .ddz {
      padding-right: 8px;
    }
    .tzx_right {
      flex: 1;
      // min-width: 0;
    }
    .company {
      font-weight: 400;
      font-size: 13px;
      color: #003350;
      padding-left: 8px;
      max-width: 280px;
    }
    .name {
      font-style: normal;
      font-weight: 400;
      font-size: 13px;
      color: #848484;
      padding-top: 9px;
      padding-right: 8px;
      width: 47px;
    }
    .del_box {
      width: 40px;
      cursor: pointer;
      padding-right: 5px;
      .del_inner {
        width: 24px;
        height: 24px;
        &:hover {
          background: rgba(0, 0, 0, 0.07);
          border-radius: 3px;
        }
      }
    }
  }
</style>
